// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sp-advanced-expand-icon {
  width: 16px;
  height: 16px;
}

.sp-advanced-expand-icon path {
  fill: var(--color-brand);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/Criteria/SPAdvancedCriteriaPopup/SPAdvancedCriteriaPopup.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".sp-advanced-expand-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.sp-advanced-expand-icon path {\n  fill: var(--color-brand);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
